import { ApiService } from ".";
import { ISettingsApiService } from "./ISettingsApiService";
import { LogosInfoModel } from "../models/LogosInfoModel";

export class SettingsApiService extends ApiService implements ISettingsApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    updateLogos(
        useCustomNotifBranding: boolean,
        leftLogo?: File,
        rightLogo?: File,
        backgroundLogo?: File,
        resetRightLogo?: boolean,
        resetBackgroundLogo?: boolean
    ): Promise<LogosInfoModel> {
        const data = new FormData();
        data.append("useCustomNotifBranding", useCustomNotifBranding ? "1" : "0");

        if (leftLogo) {
            data.append("leftLogo", leftLogo, leftLogo.name);
        }

        if (resetRightLogo) {
            data.append("resetRightLogo", "1");
        } else if (rightLogo) {
            data.append("rightLogo", rightLogo, rightLogo.name);
        }

        if (resetBackgroundLogo) {
            data.append("resetBackgroundLogo", "1");
        } else if (backgroundLogo) {
            data.append("backgroundLogo", backgroundLogo, backgroundLogo.name);
        }

        return this.post<LogosInfoModel>("settings/appearance/brand/logos", data);
    }
}
